export const IMAGE_TYPES = ["gif", "jpeg", "jpg", "png", "heic"] as const;

export const ALLOWED_FILES_TYPES = [...IMAGE_TYPES, "xls", "pdf", "doc", "docx", "xlsx"];

export const FILE_TYPES_WITH_OWNERS = ["signed_application_doc"];

export const FILE_TYPE_OTHER = "other";

export const OPTIONS_FILE_MAPPING = 8;

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
